/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useCallback, useEffect, useState, useMemo } from 'react';
// material
import { SingleSelectDropDown, Button } from '@insticator/insticator-ui';
// redux
import {useSelector, useDispatch, batch } from 'react-redux';
// utils 
import { url } from '../../utils/urls';
// components
import Header from "../structure/header/header";
import {updateSelectedSite} from "../../state/thunks/session";
// styles
import injectSheet from 'react-jss';
import styles from "./sitefilter_styles";
import { PRODUCT_COMMENTING_V2, PRODUCT_COMMENTING } from 'state/thunks/account';
import { updateCurrentPage } from 'state/slices/app';

const SiteFilter = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const {
    commenting: {
      commentingConfig
    },
    account: {
      sites = {},
      accountProducts: productAccess
    },
    session: {
      siteUUID,
      accountUUID
    },
    migrationStatus: {
      sitesWithProductsV2
    }
  } = useSelector((state) => state);


  const hasCommentingAccess = productAccess?.includes(PRODUCT_COMMENTING)
  const hasCommentingV2Access = productAccess?.includes(PRODUCT_COMMENTING_V2);

  const { commentingUnitId } = useSelector(state => state.commentingV2.commentingUnitConfig)

  const { trendingNowId } = useSelector(state => state.trendingNowV2.trendingNowConfig)

  const { articleSentimentUnitId } = useSelector(state => state.articleSentimentV2.articleSentimentConfig)

  const currentPage = useSelector(state => state.app.currentPage);

  const [selectedSite, selectSite] = useState(siteUUID)

  const [isSiteSelected, setSiteSelected] = useState(false)

  const handleSelectSite = useCallback(opt =>{
      dispatch(updateSelectedSite(opt.value));
      selectSite(opt.value)
      setSiteSelected(true)
      const legacyPages = ['/dashboard/commenting/code', '/dashboard/commenting/advanced', '/dashboard/trendsandreactions']
      const v2Pages = ['/dashboard/productmanager', '/dashboard/moderation/config']
      legacyPages.forEach(page => {
        if(currentPage.includes(page)) {
          // if current page is on legacy one
          // and if site selected has 2.0
          if(sitesWithProductsV2.includes(opt.value) ) {
            dispatch(updateCurrentPage('/dashboard/commenting/configuration'))
          }
        }
      })
      v2Pages.forEach(page => {
        if(currentPage.includes(page)) {
          // if current page is a 2.0 one
          // and if site selected doesn't have 2.0
          if(!sitesWithProductsV2.includes(opt.value) ) {
            dispatch(updateCurrentPage('/dashboard/commenting/configuration'))
          }
        }
      })
  
  }, [dispatch, currentPage]);

  const trendingNowIdParam = trendingNowId ? `&trendingNowId=${trendingNowId}` : ''

  const openCommentingTestPage = () => window.open(`${url.ccu.commentingUnits}/${commentingConfig?.data?.commentingUnitUUID}/test-page/pageTitle3`, '_blank')

  const openCommentingV2TestPage = () => window.open(url.commentingV2.preview + `?siteUuid=${selectedSite}&accountUuid=${accountUUID}&cuid=${commentingUnitId}${trendingNowIdParam}`)
  
  const openTrendingNowV2TestPage = () => window.open(url.trendingNowV2.preview + `?siteUuid=${selectedSite}&accountUuid=${accountUUID}&trendingNowId=${trendingNowId}`)
  
  const openArticleSentimentV2TestPage = () => window.open(url.articleSentimentV2.preview + `?siteUuid=${selectedSite}&accountUuid=${accountUUID}&articleSentimentId=${articleSentimentUnitId}`)

  const handleTestPageButtonClick = () => {
    if(currentPage.includes('commenting')) {
      hasCommentingV2Access ? openCommentingV2TestPage() : openCommentingTestPage()
    }
    if (currentPage.includes('trendingnow')) {
      openTrendingNowV2TestPage()
    }
    if (currentPage.includes('articlesentiment')) {
      openArticleSentimentV2TestPage()
    }
  }

  const isTestPageButtonDisabled = useMemo(() => {
    const showV1Menu = !sitesWithProductsV2.includes(siteUUID) && hasCommentingAccess
    if(currentPage.includes('commenting')) {
      if(showV1Menu) return !commentingConfig.data
    }
    return props.disableTestPageButton
  }, [commentingConfig.data, currentPage, sitesWithProductsV2, hasCommentingAccess, props.disableTestPageButton])

  return (
    <div className={`sitefilter ${props.classes.sitefilter}`}>
      <Header>
      { sites &&
          <>
          <SingleSelectDropDown 
            name={sites[selectedSite]} 
            title={'Domain'} 
            icon={'globe'} 
            searchable={false} 
            onSelect={handleSelectSite} 
            items={Object.keys(sites).map(key => ({ name: sites[key], value: key, dir: 'ASC' }))}
          />
          {!props.hideTestPageButton && 
            <Button 
              variant={'primary'} 
              text={'Test Page'} 
              handleClick={() => handleTestPageButtonClick()} 
              disabled={isTestPageButtonDisabled}
            />
          }
          </>
      }
      </Header>
    </div>
  )
});

export default SiteFilter;
